module.exports = __webpack_public_path__ + "static/img/GNSS04-2.5804fee8.png";